// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gGE3","content":"styles_content__2Asp-"};